import { useQueryClient } from 'react-query';
import { retrieveProductTechnology } from '@vfit/consumer/data-access';
import { removeCurrency } from '@vfit/consumer/hooks';
import { SoftManagerService } from '@vfit/consumer/providers';
import { setTrackLink, setTrackView, useTracking } from '@vfit/shared/data-access';
import { useCoverageToolModalProvider } from '../../coverageToolModal.context';

const CoverageToolCheckNumberCardTagging = () => {
  const { product } = useCoverageToolModalProvider();
  const queryClient = useQueryClient();

  const pageProduct = {
    product_category: 'fixed',
    product_id: `${product?.offerId}`,
    product_name: product?.slug,
    product_price: product?.price && removeCurrency(product.price),
    product_quantity: '1',
  };

  const opts = {
    event_category: 'journey',
    page_subsection: 'lock-in user data',
    page_section: 'fixed offers',
    page_type: 'form',
    journey_name: 'verify lock-in',
    product_technology: retrieveProductTechnology(),
  };

  const { trackView } = useTracking({
    event: ['journey_start'],
    event_label: 'lock-in user data',
    opts,
    pageProduct,
    visitorTrackingOpts: SoftManagerService(queryClient).getUser(),
  });

  setTrackView(trackView);
  setTrackLink(trackView);

  return null;
};

export default CoverageToolCheckNumberCardTagging;
